import * as React from 'react'
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material'

const SelectField = ({ label, onChange, value, options, id, optionName, disabled }) => {
  return (
    <FormControl fullWidth size="small">
      <InputLabel id="demo-simple-select-label">{label}</InputLabel>
      <Select
        labelId="select-label"
        onChange={onChange}
        value={value}
        label={label}
        disabled={disabled}
        style={disabled ? { color: '#ccc', backgroundColor: 'hsl(0, 0%, 95%)' } : {}}
      >
        {options.map((option, index) => (
          <MenuItem key={index} value={option[id]}>
            {option[optionName]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default SelectField